import { WorkingSection } from "./interfaces"
import axios from 'axios'

const apiURL = process.env.REACT_APP_API_URL

const getAuthHeaders = () => {
  const token = localStorage.getItem('authToken')
  if (!token) {
    throw new Error('Authorization token not found')
  }
  return {
    'Content-Type': 'application/json',
    Authorization: 'Bearer ' + token,
  }
}

export const getWorkingSectionsByEnquiry = async (enquiryId: number): Promise<WorkingSection[]> => {
  const response = await axios.get(
    `https://${apiURL}/WorkingSection/enquiry/${enquiryId}`,
    { headers: getAuthHeaders() }
  )
  return response.data
}

export const getWorkingSectionsByQuote = async (quoteId: number): Promise<WorkingSection[]> => {
  const response = await axios.get(
    `https://${apiURL}/WorkingSection/quote/${quoteId}`,
    { headers: getAuthHeaders() }
  )
  return response.data
}

export const getWorkingSectionsByJob = async (jobId: number): Promise<WorkingSection[]> => {
  const response = await axios.get(
    `https://${apiURL}/WorkingSection/job/${jobId}`,
    { headers: getAuthHeaders() }
  )
  return response.data
}

export const createWorkingSection = async (section: WorkingSection): Promise<WorkingSection> => {
  const response = await axios.post(
    `https://${apiURL}/WorkingSection`,
    section,
    { headers: getAuthHeaders() }
  )
  return response.data
}

export const updateWorkingSection = async (id: number, section: WorkingSection): Promise<WorkingSection> => {
  const response = await axios.put(
    `https://${apiURL}/WorkingSection/${id}`,
    section,
    { headers: getAuthHeaders() }
  )
  return response.data
}

export const deleteWorkingSection = async (id: number): Promise<void> => {
  await axios.delete(
    `https://${apiURL}/WorkingSection/${id}`,
    { headers: getAuthHeaders() }
  )
}
